<template>
  <span class="price-amount" :class="rootClass">
    <span class="price-amount__main">
      <span class="price-amount__value">{{ valueText }}</span>
      <span v-if="suffixText" class="price-amount__suffix">{{ suffixText }}</span>
    </span>
    <small v-if="vatVisible" class="price-amount__vat">{{ VAT_INCLUDED_HINT }}</small>
  </span>
</template>

<script>
import { VAT_INCLUDED_HINT, shouldShowVatHint } from '@/utils/pricing'
import { formatCents } from '@/utils/packagePolicy'

export default {
  name: 'PriceAmount',
  props: {
    cents: {
      type: [Number, String],
      default: null,
    },
    amount: {
      type: [Number, String],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    monthly: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    prominent: {
      type: Boolean,
      default: false,
    },
    showVat: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    VAT_INCLUDED_HINT: () => VAT_INCLUDED_HINT,
    valueText() {
      if (this.label) {
        return this.label
      }

      if (this.amount !== null && this.amount !== undefined && this.amount !== '') {
        const numeric = Number(this.amount)
        if (Number.isNaN(numeric)) {
          return this.amount
        }

        return numeric.toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR',
        })
      }

      return formatCents(this.cents)
    },
    suffixText() {
      if (this.suffix) {
        return this.suffix
      }

      if (!this.monthly || this.label) {
        return ''
      }

      const numeric = Number(this.cents)
      return !Number.isNaN(numeric) && numeric > 0 ? 'pro Monat' : ''
    },
    rootClass() {
      return {
        'price-amount--block': this.block,
        'price-amount--inline': this.inline,
        'price-amount--prominent': this.prominent,
      }
    },
    vatVisible() {
      if (this.showVat === false) {
        return false
      }

      if (this.showVat === true) {
        return true
      }

      return shouldShowVatHint({
        cents: this.label ? null : this.cents,
        amount: this.label ? null : this.amount,
        label: this.label,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.price-amount {
  display: inline;
  color: inherit;
  line-height: 1.25;
}

.price-amount--block {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
}

.price-amount--inline .price-amount__vat {
  display: inline;
  margin-left: 0.35rem;
}

.price-amount--inline .price-amount__suffix {
  margin-left: 0.25em;
}

.price-amount__main {
  display: inline;
}

.price-amount--block .price-amount__main {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.3rem;
}

.price-amount__suffix {
  color: inherit;
  font-size: 0.92em;
  font-weight: inherit;
}

.price-amount__vat {
  display: block;
  color: #6b7f92;
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.2;
}

.price-amount--prominent .price-amount__value {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: #0f3553;
}
</style>
